import React from 'react';
import './Spinner.css';

const Spinner = ({ text = "Cargando...", fullScreen = false }) => {
  return (
    <div className={`spinner-wrapper ${fullScreen ? 'fullscreen' : ''}`}>
      <div className="spinner-circle"></div>
      {text && <span className="spinner-text">{text}</span>}
    </div>
  );
};

export default Spinner;
